import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { API_ROUTES } from "../../constants/apiRoutes";

const VerifyOtp = () => {
  const [otp, setOtp] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");
  const [email, setEmail] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${API_ROUTES}Password/reset`, {
        token: otp,
        newPassword: newPassword,
        email: email,
      });
      setMessage("Password updated successfully.");
      setError("");
      // Redirect to login page or another page after success
      setTimeout(() => navigate("/login"), 2000);
    } catch (error) {
      console.error("Error updating password", error);
      setError("Error updating password. Please try again.");
      setMessage("");
    }
  };

  return (
    <div className="flex justify-center items-center min-h-screen bg-base-200">
      <div className="w-full max-w-md p-8 space-y-4 shadow-lg rounded-lg">
        <h2 className="text-2xl font-bold text-center">
          Verify Token and Reset Password
        </h2>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="form-control">
            <label className="label" htmlFor="otp">
              <span className="label-text">Token</span>
            </label>
            <input
              type="text"
              id="otp"
              className="input input-bordered w-full"
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
              required
            />
          </div>
          <div className="form-control">
            <label className="label" htmlFor="otp">
              <span className="label-text">Email</span>
            </label>
            <input
              type="text"
              className="input input-bordered w-full"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div className="form-control">
            <label className="label" htmlFor="newPassword">
              <span className="label-text">New Password</span>
            </label>
            <input
              type="password"
              id="newPassword"
              className="input input-bordered w-full"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              required
            />
          </div>
          <button type="submit" className="btn btn-primary w-full">
            Reset Password
          </button>
          {message && (
            <div className="text-green-500 text-center mt-4">{message}</div>
          )}
          {error && (
            <div className="text-red-500 text-center mt-4">{error}</div>
          )}
        </form>
      </div>
    </div>
  );
};

export default VerifyOtp;
